export const BLANK_ADDRESSES = '/blank-addresses';
export const TOOLS_AND_GUIDE = '/tools-and-guide';
export const PARTNER_ORG = '/partner-orgs';
